import axios from 'axios';

interface FunnelStep {
  step: string;
  label: string;
  count: number;
  uniqueSessions: number;
}

interface TrendPoint {
  period: string;
  started: number;
  completed: number;
  conversionRate: number;
}

export interface SignupFunnelData {
  funnel: FunnelStep[];
  trend: TrendPoint[];
}

export type FunnelPeriod = 'week' | 'month' | 'year';

class ServiceSignupFunnelController {
  async getFunnelData(period: FunnelPeriod = 'month', from?: string, to?: string): Promise<SignupFunnelData> {
    const params: Record<string, string> = { period };
    if (from) params.from = from;
    if (to) params.to = to;
    const response = await axios.get('/api/superadmin/signup-funnel', { params });
    return response.data;
  }
}

export const ServiceSignupFunnel = new ServiceSignupFunnelController();
